import React from "react";
import { Box, styled } from "@mui/material";
import ChatList from "./chat-list";
import ChatDetail from "./chat-detail";

const StyledContainer = styled(Box)(({ theme }) => ({
  height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: `linear-gradient(to bottom, ${theme.palette.primary.main} 15%, transparent 15%, transparent 50%)`,
}));

const StyledRoot = styled(Box)(({ theme }) => ({
  width: "90%",
  height: "90%",
  backgroundColor: theme.palette.primary.contrastText,
  boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
  display: "flex",
}));

const Home = () => {
  return (
    <StyledContainer>
      <StyledRoot>
        <ChatList />
        <ChatDetail />
      </StyledRoot>
    </StyledContainer>
  );
};

export default Home;
